export const environment = {
  production: false,
  apiUrl: 'https://api.asktellydev.infocision.ai',
  apiEndpoints: {
    auth: '/auth',
    chat: '/chat',
    datasets: '/datasets',
    analytics: '/analytics'
  }
}; 